import type React from 'react';

function SkrymIconWithBackground(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 263.48 263.48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Skrym Icon With Background</title>

      <g id="Layer_2-2" data-name="Layer 2">
        <rect width="263.48" height="263.48" fill="#f8ea21" />
        <path d="M171.47,184.25H49.44c-5.77,0-10.46-4.69-10.46-10.46V51.77c0-5.77,4.69-10.46,10.46-10.46h122.02c5.77,0,10.46,4.69,10.46,10.46v122.02c0,5.77-4.69,10.46-10.46,10.46h0Zm-111.82-20.66h101.62V61.97H59.64v101.62Z" />
        <path d="M212.77,222.16H93.28c-6.46,0-11.72-5.26-11.72-11.72V90.95c0-6.46,5.26-11.72,11.72-11.72h119.49c6.46,0,11.72,5.26,11.72,11.72v119.49c0,6.46-5.26,11.72-11.72,11.72Zm-110.56-20.66h101.62V99.88H102.21v101.62Z" />
        <rect
          x="61.76"
          y="46.7"
          width="20.66"
          height="58.35"
          transform="translate(-32.2 84.69) rotate(-51.3)"
        />
        <rect
          x="180.39"
          y="160.89"
          width="20.66"
          height="61.73"
          transform="translate(-78.98 211.96) rotate(-49.44)"
        />
      </g>
    </svg>
  );
}

export default SkrymIconWithBackground;
